/** Prototype time-and-materials palette — mirrors proto-time-and-materials v0.1.7 */
export const TM = {
  ink: '#26242e',
  inkSoft: '#4a4754',
  muted: '#8a8794',
  line: '#e8e6ee',
  lineSoft: '#f1eff5',
  shell: '#eef0f4',
  orange: '#e8631a',
  orangeSoft: '#fff3ec',
  purple: '#5b27a6',
  purpleDeep: '#4c1d95',
  purpleSoft: '#f3eefc',
  blue: '#2d6cdf',
  green: '#2e9e4f',
  greenSoft: '#eafaef',
  amber: '#c77a12',
  red: '#c0392b',
  field: '#f6f5f9',
  white: '#ffffff',
} as const;

export type PricingMode = 'Do & Charge' | 'Fixed price';
